import { idTypesConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  response: null,
  error: null
};

export const idTypes = (state = initialState, action) => {
  switch (action.type) {
    case idTypesConstants.GET_IDTYPES_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case idTypesConstants.GET_IDTYPES_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case idTypesConstants.GET_IDTYPES_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case idTypesConstants.GET_IDTYPES_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
